import axios from '@/utils/request'
import { AxiosPromise } from 'axios'
import { BaseResponse, ResponseStatus } from '.'
import { MatchEntity, MatchGameListItemWithResultResponse } from './match'
import { TournamentEntity } from '@/api/tournament'
import { TournamentTeamEntity } from '@/api/tournamentTeam'
import { VenueEntity } from '@/api/venue'

export { BaseResponse, ResponseStatus }

export interface MemberSnippetEntity {
  memberId: string
  nickname: string
  avatar: string
}

export interface MemberEntity {
  memberId: string
  contactEmail: string
  contactPhone: string
  nickname: string
  level: number
  firstName: string
  lastName: string
  displayName: string
  country: string
  birthDate?: number
  gender: string
  gameAccounts: MemberGameAccountEntity[]
  homeShop: VenueEntity
  homeShopTotalLoyaltyPoint: number
  avatar: string
  isNewMember?: boolean
}

export interface EditProfileRequest {
  nickname?: string
  birthDate?: number
  country?: string
  avatar?: string
}

export interface MemberGameAccountEntity {
  id: string
  game: string
  nickname: string
  isLocked: boolean
}

export interface AddMemberGameAccountRequest {
  game: string
  nickname: string
}

export interface UpdateMemberGameAccountRequest {
  nickname: string
}

export class MemberAPI {
  public static API_PREFIX = '/member/v1'

  /**
   * Get member
   * @param memberId MemberId
   * @returns {BaseResponse<MemberEntity>} API Response
   */
  public static getMember(
    memberId: string = '@me'
  ): AxiosPromise<BaseResponse<MemberEntity>> {
    return axios.get(`${this.API_PREFIX}/members/${memberId}`)
  }

  /**
   * Edit member profile
   * @param request {EditProfileRequest} edit profile request
   * @returns {BaseResponse}
   */
  public static editProfile(
    request: EditProfileRequest
  ): AxiosPromise<BaseResponse> {
    return axios.post(`${this.API_PREFIX}/profile`, request)
  }

  /**
   * Add game account under a member (AddMemberGameAccount)
   * @param request {AddMemberGameAccountRequest}
   */
  public static addMemberGameAccount(
    request: AddMemberGameAccountRequest
  ): AxiosPromise<BaseResponse> {
    return axios.post(`${this.API_PREFIX}/game-accounts`, request)
  }

  /**
   * Update game account udner a member (UpdateMemberGameAccount)
   * @param gameAccountId {string} Game account id
   * @param request {UpdateMemberGameAccountRequest} add account request
   */
  public static updateMemberGameAccount(
    gameAccountId: string,
    request: UpdateMemberGameAccountRequest
  ): AxiosPromise<BaseResponse> {
    return axios.put(
      `${this.API_PREFIX}/game-accounts/${gameAccountId}`,
      request
    )
  }

  /**
   * Remove game account under a member (RemoveMemberGameAccount)
   * @param gameAccountId {string} Game account id
   * @returns {BaseResponse}
   */
  public static removeMemberGameAccount(
    gameAccountId: string
  ): AxiosPromise<BaseResponse> {
    return axios.delete(`${this.API_PREFIX}/game-accounts/${gameAccountId}`)
  }
}
